



























































import { Component, Vue, Watch } from "vue-property-decorator";
import firebase from "firebase";
import UserModel, { UserDb } from "@/models/User";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import moment, { version } from "moment";
import { mask } from "vue-the-mask";
import _debug from "debug";

const debug = _debug("Mediacao:views:UsuarioCadastro.vue");

const userModule = getModule(UserModule, store);

@Component({
    components: {},
    directives: { mask },
})
export default class UsuarioCadastro extends Vue {
    private usuarioDados: UserDb = {};
    private dataNascimentoFormatada = "";
    private menuDataNascimento = false;
    private usuarioExiste = false;
    private cellMask: string[] = ["(##) ####-####", "(##) #####-####"];
    private snackbar = false;
    private snackbarMessage = "";
    private modoProprio = false;
    private formValid = false;
    private formMessage = "É necessário preencher seus dados antes de continuar";

    private rules: any = {
        nome: [(v: string) => !!v || "O Nome completo é obrigatório!", (v: string) => (v && v.length <= 260) || "O Nome deve ter no máximo 260 caracteres!"],
        email: [
            (v: string) => !!v || "O email é obrigatório!",
            (v: string) =>
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(v) ||
                "Email inválido, por favor digite um email válido!",
        ],
        dataNascimento: [(v: string) => !!v || "A Data de Nascimento é obrigatória!"],
        cellPhone: [(v: string) => !!v || "O número do telefone celular é obrigatório!"],
        cpf: [(v: string) => !!v || "O número do CPF é obrigatório!"],
    };

    @Watch("snackbar")
    public onChildChanged(val: string, oldVal: string) {
        if (val && this.snackbarMessage === "Dados salvos com sucesso!") {
            setTimeout(() => {
                this.$router.push("home");
            }, 800);
        }
    }

    @Watch("menuDataNascimento", { immediate: true, deep: true })
    public onMenuDataNascimentoChanged(val: boolean, oldVal: boolean) {
        const picker = this.$refs.dataNascimentoPicker as any;
        if (val) {
            if (this.usuarioDados.dataNascimento && /\d{4,4}-\d{2,2}-\d{2,2}/.test(this.usuarioDados.dataNascimento)) {
                setTimeout(() => {
                    picker.activePicker = "DATE";
                });
            } else {
                setTimeout(() => {
                    picker.activePicker = "YEAR";
                });
            }
        }
    }
    private showMenuDataNascimento() {
        debug("showMenu!");
        this.menuDataNascimento = true;
    }

    private created() {
        if (this.$route.query.modo === "proprio") {
            Object.assign(this.usuarioDados, userModule.getUser.userDb as UserDb);
            this.modoProprio = true;
            this.selecionouData();
        }
    }

    private selecionouData() {
        debug("Selecionou data!");
        this.menuDataNascimento = false;
        this.dataNascimentoFormatada = this.usuarioDados.dataNascimento ? moment(this.usuarioDados.dataNascimento).format("DD/MM/YYYY") : "";
    }

    private leDataFormatada(event: KeyboardEvent) {
        try {
            debug("leDataFormatada", this.dataNascimentoFormatada, event);
            if (!event) {
                this.$set(this.usuarioDados, "dataNascimento", "");
            } else {
                const data = moment(this.dataNascimentoFormatada, "DD/MM/YYYY", true);
                if (data.isValid()) {
                    this.$set(this.usuarioDados, "dataNascimento", data.format("YYYY-MM-DD"));
                    this.menuDataNascimento = false;
                }
            }
        } catch (e) {
            console.error("Erro lendo data", e);
        }
    }

    private async salvar() {
        console.log("UsuarioCadastro.salvar");
        debug("Salvando dados do usuário!", this.usuarioDados);
        const saved = await UserModel.setUserdb(this.usuarioDados);
        const newUser = userModule.getUser.userDb;
        Object.assign(newUser, saved);
        userModule.changeUser(new UserModel(userModule.getUser.firebase, newUser)).then(() => {
            this.snackbarMessage = "Dados salvos com sucesso!";
            this.snackbar = true;
            if (this.modoProprio) {
                this.$router.replace("/");
            }
        });
    }

    private cancelar() {
        debug("Limpando dados do usuário!", this.usuarioDados);
        this.usuarioDados = Object.assign({}, userModule.getUser.userDb);
    }
}
